const topics = [
  { name: '顶流塌房', count: '12.4万', hot: true },
  { name: '网红翻车', count: '9.8万', hot: true },
  { name: '聊天记录泄露', count: '8.2万', hot: true },
  { name: '综艺内幕', count: '7.5万', hot: false },
  { name: '艺人税务', count: '6.3万', hot: false },
  { name: '影视泄密', count: '5.9万', hot: false },
  { name: '选角潜规则', count: '4.7万', hot: false },
  { name: '恋爱实锤', count: '3.8万', hot: false },
  { name: '合约纠纷', count: '3.1万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">话题标签</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">热门话题</h2>
          <p className="text-foreground-600 text-sm mt-2">按热度浏览你最关心的吃瓜话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#topics"
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100 text-primary-700'
                  : 'bg-background-50 border-background-200 hover:border-secondary-300 text-foreground-700 hover:bg-background-100'
              }`}
            >
              <span className="text-sm font-medium">{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-primary-500' : 'text-foreground-400'}`}>{topic.count}</span>
              {topic.hot && <i className="ri-fire-line text-primary-500 text-xs"></i>}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}